module.exports = __webpack_public_path__ + "img/Data_and_More_Logo_Dark.f803ca2d.png";